module.exports = __webpack_public_path__ + "img/background-login.344699b3.png";